<template>
  <div
    class="image-form-container card mt-3 border"
  >
    <div class="card-body">
      <div class="d-flex justify-content-start" style="gap: 5px">
        <div class="hidden-input-container">
          <b-button variant="primary">افزودن عکس</b-button>
          <input
            @input="fileAdded"
            ref="fileInput"
            type="file"
            accept="image/*"
            multiple
            class="hidden-input"
          />
        </div>
      </div>

      <div class="product-images-container product-image-grid">
          
            <div
             
              class="product-image-cell"
              v-for="image in realValue"
              :key="image.key"
            >
              <button
                @click="deleteImage(image.key)"
                class="delete-button btn btn-danger"
              >
                <i class="fa fa-trash" data-toggle="tooltip"></i>
              </button>
              <ImageHolder class="image-holder">
                <img style="height: auto" :src="image.url" />
              </ImageHolder>
            </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductImagesImpl from "@@/core/components/product/ProductImages/ProductImagesImpl";
export default {
  extends: ProductImagesImpl,
};
</script>

<style
  scoped
  src="@@/core/components/product/ProductImages/ProductImagesStyle.css"
></style>
